export default __webpack_public_path__ + "static/media/Aura-Egg__85.48f92ac5.png";